module.exports = __webpack_public_path__ + "media/shape/border-triangle-38e0c112.png";